import { useState } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  defaultActive?: boolean
  onAdd?: () => Promise<void> | void
  onRemove?: () => Promise<void> | void
  className?: string
  variant?: 'default' | 'borderless'
}

export const FavoriteHeart = ({
  defaultActive = false,
  onAdd,
  onRemove,
  className,
  variant = 'default',
}: Props) => {
  const [active, setActive] = useState(defaultActive)
  const [animate, setAnimate] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()

    if (loading) return

    const next = !active
    setLoading(true)

    try {
      if (next) {
        await onAdd?.()
        setActive(true)

        setAnimate(true)
        setTimeout(() => setAnimate(false), 560)
      } else {
        await onRemove?.()
        setActive(false)
      }
    } catch {
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      className={clsx(
        s.button,
        variant === 'borderless' && s.borderless,
        active && s.active,
        animate && s.animate,
        loading && s.loading,
        className,
      )}
    >
      <span className={s.burst} />

      {loading ? (
        <span className={s.loader} />
      ) : (
        <svg
          viewBox="0 0 18 18"
          className={s.icon}
          fill="none"
        >
          <path
            d="M12.8691 2C13.4616 2 13.9951 2.10691 14.4805 2.31152C14.9722 2.51885 15.4024 2.81304 15.7764 3.2002C16.155 3.58801 16.4515 4.04788 16.667 4.5957C16.8852 5.13136 17 5.733 17 6.4248C17 7.45606 16.7205 8.50334 16.126 9.57715C15.5192 10.6669 14.6489 11.7543 13.4941 12.835C12.3384 13.9223 10.9655 14.9658 9.36719 15.9648C9.25222 16.0392 9.14275 16.0974 9.02441 16.1484L8.99023 16.1631L8.96973 16.1543L8.80957 16.0742C8.75854 16.0459 8.70916 16.0161 8.66211 15.9844L8.63281 15.9648C7.23372 15.0903 6.00449 14.1816 4.94141 13.2402L4.49609 12.835C3.49147 11.8896 2.70169 10.9388 2.11328 9.98535L1.87402 9.57715C1.27951 8.50334 1 7.45606 1 6.4248C1.00004 5.73217 1.11232 5.12944 1.32031 4.60352C1.54245 4.05189 1.84 3.58937 2.20996 3.20508C2.59162 2.81512 3.02658 2.51936 3.51953 2.31152C4.01339 2.10446 4.54483 2.00005 5.12109 2C5.76993 2 6.3666 2.23545 6.97754 2.54492C7.51158 2.81289 7.90797 3.14536 8.19727 3.53516L9.00391 4.62109L9.80566 3.53125C10.0957 3.13723 10.4882 2.80744 11.0078 2.54785C11.6304 2.23498 12.2267 2 12.8691 2Z"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  )
}
